import React from 'react';
import { MIconInteractiveProps } from './MIconInteractive.types';
import * as Styled from './MIconInteractive.styles';
import { AIcon } from '../../atoms/AIcon';

const COMPONENT_NAME = 'm-web-ui-kit-MIconInteractive';
const TEST_ID = 'web-ui-kit-MIconInteractive';

export function MIconInteractive({ aIcon, ctaLink, openInANewTab, onClick, ariaLabel }: MIconInteractiveProps) {
  const content = aIcon ? <AIcon {...aIcon} /> : null;

  const opensInNewTab = openInANewTab === true || openInANewTab === 'true';

  if (ctaLink) {
    return (
      <Styled.AnchorWrapper
        href={ctaLink}
        target={opensInNewTab ? '_blank' : '_self'}
        rel={opensInNewTab ? 'noopener noreferrer' : undefined}
        aria-label={ariaLabel}
        data-component-name={COMPONENT_NAME}
        data-testid={TEST_ID}
      >
        {content}
      </Styled.AnchorWrapper>
    );
  }

  return (
    <Styled.Wrapper onClick={onClick} data-component-name={COMPONENT_NAME} data-testid={TEST_ID}>
      {content}
    </Styled.Wrapper>
  );
}
